import React from 'react';
import styles from '../index.module.scss';

const GasScheduleLegend: React.FC = () => {
  return (
    <div className={styles.legend}>
      <div className={styles.legendItem}>
        <span className={`${styles.legendSwatch} ${styles.legendDanger}`} />
        <span>用能时间范围内阀门未开启</span>
      </div>
      <div className={styles.legendItem}>
        <span className={`${styles.legendSwatch} ${styles.legendWarning}`} />
        <span>非用能时间范围内阀门未关闭</span>
      </div>
    </div>
  );
};

export default GasScheduleLegend;
